import { createContext, useState, useContext, useEffect } from "react";

const CountryContext = createContext();
export default CountryContext;

export const CountryContextProvider = ({ children }) => {
  const [country, setCountry] = useState("PT");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        setCountry(data.country_code || "PT");
        setIsLoading(false);
      })
      .catch(() => {
        setCountry("PT");
        setIsLoading(false);
      });
  }, []);

  return (
    <CountryContext.Provider value={{ country, isLoading }}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCountry = () => {
  const context = useContext(CountryContext);

  if (context === undefined) {
    throw new Error("useCountry was used outside of its Provider");
  }

  return context;
};
